// extracted by mini-css-extract-plugin
export var animatedImage = "index-module--animatedImage--a60f6 flex justify-center items-center relative overflow-hidden w-full h-full";
export var image = "index-module--image--3bcbe absolute min-w-full min-h-full";